import React, { forwardRef } from 'react';

import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { validate } from '@vlabs/shared';
import { selectListOptions } from '@vlabs/shared/selectors/listSelectors';
import { useSelector } from 'react-redux';

import st from './popovers.module.sass';
import { useCardsFilters } from '../useCardsFilters';

function ListsFilterPopover(
  {
    name = 'lists',
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const listsOptions = useSelector(selectListOptions);
  const { filters, updateFilters } = useCardsFilters();

  const handleChangeLists = (nextValue: string[]) => {
    updateFilters({
      list_ids: nextValue.length > 0 ? nextValue : undefined,
    });
  };

  const reset = () => updateFilters({ list_ids: undefined });
  return (
    <PopoverWithButton
      {...props}
      onClickReset={reset}
      ref={ref}
    >
      <OptionsFilter
        isCreatable
        name={name}
        onChange={handleChangeLists}
        options={listsOptions}
        validateProp={validate.UUIDValidator()}
        value={filters.list_ids ?? []}
        visibleCount={5}
      />
      <div className={st.Divider} />
    </PopoverWithButton>
  );
}

const ListsFilterPopoverWithRef = forwardRef(ListsFilterPopover);
export { ListsFilterPopoverWithRef as ListsFilterPopover };
